import * as THREE from 'three';

export interface ReplaceRootOptions {
  readonly disposePrevious?: boolean;
}

export function disposeObjectTree(root: THREE.Object3D): void {
  root.traverse((object) => {
    if (!(object instanceof THREE.Mesh)) return;
    const mesh = object as THREE.Mesh<THREE.BufferGeometry, THREE.Material | THREE.Material[]>;
    mesh.geometry.dispose();
    const materials = Array.isArray(mesh.material) ? mesh.material : [mesh.material];
    for (const material of materials) material.dispose();
  });
}

export class SceneRootManager {
  readonly host = new THREE.Group();
  #root: THREE.Group;

  constructor(name = 'content-root') {
    this.host.name = `${name}:host`;
    this.#root = new THREE.Group();
    this.#root.name = name;
    this.host.add(this.#root);
  }

  get root(): THREE.Group {
    return this.#root;
  }

  replaceRoot(nextRoot: THREE.Group, options: ReplaceRootOptions = {}): THREE.Group {
    if (nextRoot === this.#root) return this.#root;
    const previous = this.#root;
    this.host.remove(previous);
    this.#root = nextRoot;
    this.host.add(nextRoot);
    if (options.disposePrevious) disposeObjectTree(previous);
    return previous;
  }
}
